import CTLBooleanCell from "application/components/CTLBooleanCell";
import CTLUnReadCell from "application/components/CTLUnReadCell";
import DefaultCell from "application/components/DefaultCell";
import AuthenticationService from "application/modules/authentication/AuthenticationService";
import { reportMenus } from "globals/configuration/reports";
import { ExtensionReportMenus } from "globals/configuration/reports/ExtensionReports";
import { billingUserMenus } from "globals/configuration/reports/billingUserMenus";
const buildModes = () => {
  const source = AuthenticationService.isBillingOnlyUser()
    ? billingUserMenus
    : AuthenticationService.allowApollo()
      ? ExtensionReportMenus
      : reportMenus;
  return source.map((item) => ({
    id: item.key,
    name: item.name,
    iconName: item.icon,
    url: item.url,
    description: item.description,
    disabled: item.disabled,
    productionReady: item.productionReady,
  }));
};

const Attributes = {
  enableAddButton: false,
  enableUpdateTableRecords: true,
  enableDownloadButton: true,
  enableAdvanceSearch: true,
  enableDownloadPdf: true,
  enableRefresh: true,
  // modes is a getter so the role check runs at access-time, not at module-eval
  // time — layouts/index.js imports this module at app bootstrap, before login
  // populates sessionStorage with roles.
  get modes() {
    return buildModes();
  },
};

const operationURLS = {
  list: "/extensionCDR/list",
  pdfDownload: "/extensionCDR/generateAndDownloadPdf",
  csvDownload: "/extensionCDR/downloadCSV",
};

const getColumns = () => {
  return [
    {
      Header: "Call Direction",
      accessor: "coralCallDirection",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Caller No",
      accessor: "callerIdNumber",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "caller Name",
      accessor: "callerName",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Destination No",
      accessor: "destinationNumber",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Destination Name",
      accessor: "destinationName",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Start Time",
      accessor: "startEpoch",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dateTime: true,
      dataType: "date",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Answer Time",
      accessor: "answerEpoch",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dateTime: false,
      dataType: "date",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "End Time",
      accessor: "endEpoch",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "date",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "TalkTime (HH:MM:SS)",
      accessor: "talkDuration",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Call Answered",
      accessor: "callConnected",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      controlType: "boolean",
      dataType: "boolean",
      filterControlType: "boolean",
      filterValue: "boolean",
      sortDisable: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "call Type",
      accessor: "callType",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dateTime: false,
      dataType: "date",
      downloadReports:false,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "MOS",
      accessor: "mos",
      downloadReports:false,
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Feature Name",
      accessor: "coralFeatureCode",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
  ];
};

export { getColumns, Attributes, operationURLS };
